import { RoutablePage, isMobileQuery } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __spreadArray, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { STATIC_PAGES_NAMESPACE } from '../../store/modules/static-pages/static-pages.store.js';
import { store } from '../../store/index.js';
import { StaticPageMixin } from '../../mixins/static-page.mixin.js';
import '../../mixins/promotions.mixin.js';
import '../../mixins/landing-page.mixin.js';
import '../../mixins/competitions.mixin.js';

var staticPagesModule = namespace(STATIC_PAGES_NAMESPACE);
var StaticPageComponent = /** @class */ (function (_super) {
    __extends(StaticPageComponent, _super);
    function StaticPageComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pages = [];
        _this.activePage = null;
        _this.isMobile = false;
        return _this;
    }
    StaticPageComponent.prototype.onError = function () {
        this.routeTo({ route: RoutablePage.NOT_FOUND });
    };
    StaticPageComponent.prototype.handleRedirectToLink = function (page) {
        if (!page.description)
            return;
        this.activePage = page.description;
        this.routeTo({ route: page.description });
    };
    StaticPageComponent.prototype.isActive = function (page) {
        var _this = this;
        var currentPath = this.getCurrentPath();
        var matches = this.pages.some(function (item) { return _this.normalizePath(item.description) === currentPath; });
        if (!matches)
            return true;
        if (this.activePage) {
            return (this.normalizePath(this.activePage) ===
                this.normalizePath(page.description));
        }
        return this.normalizePath(page.description) === currentPath;
    };
    StaticPageComponent.prototype.hasWhiteOverlay = function (page) {
        var _this = this;
        var currentPath = this.getCurrentPath();
        var matches = this.pages.some(function (item) { return _this.normalizePath(item.description) === currentPath; });
        if (!matches) {
            return false;
        }
        if (this.isActive(page)) {
            return false;
        }
        return true;
    };
    StaticPageComponent.prototype.normalizePath = function (page) {
        if (!page)
            return '';
        return page.split('?')[0].replace(/\/+$/, '') || '/';
    };
    StaticPageComponent.prototype.getCurrentPath = function () {
        return this.normalizePath(window.location.pathname);
    };
    StaticPageComponent.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var lang, category, _a, sorted, currentPath, active;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        lang = this.magicConfig.language;
                        category = this.category;
                        _a = this;
                        return [4 /*yield*/, isMobileQuery()];
                    case 1:
                        _a.isMobile = _b.sent();
                        return [4 /*yield*/, this.fetchStaticPagesData(category, lang)];
                    case 2:
                        _b.sent();
                        sorted = __spreadArray([], this.getCategory);
                        this.pages = sorted.sort(function (a, b) {
                            if (a.slug === 'mobile-free-to-play-link')
                                return -1;
                            if (b.slug === 'mobile-free-to-play-link')
                                return 1;
                            return 0;
                        });
                        currentPath = this.getCurrentPath();
                        active = this.pages.find(function (item) { return _this.normalizePath(item.description) === currentPath; });
                        this.activePage = active ? active.description : null;
                        return [2 /*return*/];
                }
            });
        });
    };
    StaticPageComponent.prototype.fetchStaticPagesData = function (category, lang) {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.fetchCategory({ category: category, lang: lang })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(StaticPageComponent.prototype, "isMobileCategoy", {
        get: function () {
            return this.category === 'mobile';
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        staticPagesModule.Getter('getCategory'),
        __metadata("design:type", void 0)
    ], StaticPageComponent.prototype, "getCategory", void 0);
    __decorate([
        staticPagesModule.Action('fetchCategory'),
        __metadata("design:type", Object)
    ], StaticPageComponent.prototype, "fetchCategory", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], StaticPageComponent.prototype, "category", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], StaticPageComponent.prototype, "slug", void 0);
    StaticPageComponent = __decorate([
        Component({
            name: 'static-pages-navigation',
            store: store,
        })
    ], StaticPageComponent);
    return StaticPageComponent;
}(Mixins(StaticPageMixin)));

export default StaticPageComponent;
